import { useEffect, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../../assets/images/admin-logo.png';
import Affiliate from '../../assets/images/sidebar/affiliate.svg?react';
import Coin from '../../assets/images/sidebar/coins.svg?react';
import Commision from '../../assets/images/sidebar/commision.svg?react';
import Dashboard from '../../assets/images/sidebar/dashboard.svg?react';
import Gift from '../../assets/images/sidebar/gift.svg?react';
import Greeting from '../../assets/images/sidebar/greeting.svg?react';
import Report from '../../assets/images/sidebar/mange.svg?react';
import Query from '../../assets/images/sidebar/query.svg?react';
import Refral from '../../assets/images/sidebar/refral.svg?react';
import Subscription from '../../assets/images/sidebar/subscription.svg?react';
import Faq from '../../assets/images/sidebar/faq.svg?react';
import User from '../../assets/images/sidebar/user.svg?react';
import useUserStore from '../../Stores/UserStore';
import { isNullOrEmpty } from '../../Utils/Utils';
import Styles from './Sidebar.module.css';

const Sidebar = ({ sideBarClass, disable = false }) => {
  const location = useLocation();
  const [openItem, setOpenItem] = useState(null);
  const isCollapsed = sideBarClass === 'collapsed';
  const { role } = useUserStore();
  const menuItems = [
    {
      roles: ['employee', 'user'],
      id: '1',
      label: 'Dashboard',
      link: role === 'admin' ? '/admin/dashboard' : role === 'affiliate' ? '/affiliate/dashboard' : '/dashboard',
      icon: Dashboard,
    },
    {
      roles: ['admin'],
      id: 'admin-dashboard',
      label: 'Dashboard',
      link: '/admin/dashboard',
      icon: Dashboard,
    },
    {
      roles: ['admin'],
      id: 'user-mgmt',
      label: 'User Management',
      link: '/admin/user-management',
      icon: User,
    },
    {
      roles: ['admin'],
      id: 'affi-mngmt',
      label: 'Affiliate Management ',
      link: '/admin/affiliate-management',
      icon: Affiliate,
    },
    {
      roles: ['admin'],
      id: 'coin-log',
      label: 'Coin Logs',
      link: '/admin/coin-logs',
      icon: Coin,
    },
    {
      roles: ['admin'],
      id: 'gist-log',
      label: 'Gift Purchase Logs',
      link: '/admin/gift-purchase-logs',
      icon: Gift,
    },
    {
      roles: ['admin'],
      id: 'greeting-card',
      label: 'Greeting Card Purchases Logs',
      link: '/admin/greeting-card-log',
      icon: Greeting,
    },
    {
      roles: ['admin'],
      id: 'ref-mgmt',
      label: 'Refral Point Management',
      link: '/admin/refral-point-management',
      icon: Refral,
    },
    {
      roles: ['admin'],
      id: 'promo-mgmt',
      label: 'Commission Management',
      link: '/admin/commission-management',
      icon: Commision,
    },
    {
      roles: ['admin'],
      id: 'report-mngmt',
      label: 'Report Management',
      link: '/admin/report-management',
      icon: Report,
    },
    {
      roles: ['admin'],
      id: 'subs-log',
      label: 'Subscription Logs',
      link: '/admin/subscription-logs',
      icon: Subscription,
    },
    {
      roles: ['admin'],
      id: 'query-mgmt',
      label: 'Query Management',
      link: '/admin/query-management',
      icon: Query,
    },
    {
      roles: ['admin'],
      id: 'faq-mngmt',
      label: 'FAQs Management',
      link: '/admin/faq-management',
      icon: Faq,
    },
    {
      roles: ['affiliate'],
      id: 'affiliate-dashboard',
      label: 'User data',
      link: '/affiliate/dashboard',
      icon: User,
    }
  ];
  const toggleItem = (id) => {
    setOpenItem(openItem === id ? null : id);
  };

  useEffect(() => {
    if (isCollapsed) {
      setOpenItem(null); // Close all items when sidebar collapses
    }
  }, [isCollapsed]);

  useEffect(() => {
    if (sideBarClass) {
      setOpenItem(null);
    }
  }, [sideBarClass]);

  const renderLink = (to, children) => {
    if (disable) {
      return <div className={Styles.disabledLink}>{children}</div>;
    }
    return <Link to={to}>{children}</Link>;
  };

  return (
    <div
      className={`${Styles.sidebar} ${Styles[sideBarClass]} ${
        disable ? Styles.disabled : ''
      }`}
      id="sidebar"
    >
      {disable && <div className={Styles.overlay}></div>}
      <div className={Styles['sidebar-title-wrapper']}>
        {renderLink(
          role === 'admin' ? '/admin/dashboard' : role === 'affiliate' ? '/affiliate/dashboard' : '/dashboard',
          <h2 className={`${Styles['sidebar-title']} sidebar-logo`}>
            <img src={Logo} alt="Logo" className={Styles['sidebar-logo']} />
          </h2>
        )}
      </div>
      <div className={Styles['dropdown-container']}>
        {menuItems.map((item) =>
          item.roles.includes(role) ? (
            <div key={item.id} className={Styles['menu-item-container']}>
              {/* Button with no sub items */}
              {item?.link && !item?.subItems?.length ? (
                renderLink(
                  item.link,
                  <button
                    className={`${Styles['menu-item']} ${
                      location.pathname.includes(item.link) ? Styles.active : ''
                    }`}
                    onClick={() => toggleItem(item.id)}
                    aria-expanded={openItem === item.id}
                    aria-controls={`submenu-${item.id}`}
                  >
                    {item.icon && <item.icon className={Styles.icon} />}
                    <p className="m-0">{item.label}</p>
                    {item.subItems ? (
                      <FaChevronDown
                        className={`${Styles.chevron} ${
                          openItem === item.id ? Styles.open : ''
                        }`}
                      />
                    ) : (
                      ''
                    )}
                  </button>
                )
              ) : (
                <>
                  {/* Button with sub items */}
                  <button
                    className={`${Styles['menu-item']} ${
                      location.pathname.includes(item.link) ? Styles.active : ''
                    }`}
                    onClick={(e) => {
                      if (disable) {
                        e.preventDefault();
                        return;
                      }
                      toggleItem(item.id);
                    }}
                    aria-expanded={openItem === item.id}
                    aria-controls={`submenu-${item.id}`}
                  >
                    {item.icon && <item.icon className={Styles.icon} />}
                    <p className="m-0">{item.label}</p>
                    {item.subItems ? (
                      <FaChevronDown
                        className={`${Styles.chevron} ${
                          openItem === item.id ? Styles.open : ''
                        }`}
                      />
                    ) : (
                      ''
                    )}
                  </button>
                </>
              )}
              {!isNullOrEmpty(item.subItems) && (
                <div
                  id={`submenu-${item.id}`}
                  className={`${Styles.submenu} ${
                    openItem === item.id ? Styles.open : ''
                  }`}
                >
                  {item.subItems.map((subItem, index) => {
                    return subItem.link ? (
                      <div key={subItem.link}>
                        {renderLink(
                          subItem.link,
                          <div
                            className={`${Styles['submenu-item']} ${
                              index === item.subItems.length - 1
                                ? Styles['last-item']
                                : ''
                            } ${
                              location.pathname.includes(subItem.link)
                                ? Styles.active
                                : ''
                            }`}
                          >
                            {subItem.name}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        key={subItem.name}
                        className={`${Styles['submenu-item']}`}
                      >
                        <p className="mb-0 fw-bold fst-italic">
                          {subItem.name}
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default Sidebar;
